/******************************************************************************
 * FILE:
 * src/modules/expense_management/workflow/services/approvalMatrixService.js
 *
 * MODULE:
 * Expense Management
 *
 * FEATURE:
 * Approval Matrix
 *
 * PURPOSE:
 * Frontend API Client for Approval Matrix
 *
 * ARCHITECTURE:
 * • Axios Client
 * • No Business Logic
 * • Returns Backend Response Data
 ******************************************************************************/

import axiosClient from "../../../../api/axiosClient";

/**
 * --------------------------------------------------------------------------
 * GET APPROVAL MATRIX LIST
 * --------------------------------------------------------------------------
 *
 * Backend:
 * GET /api/expense-management/approval-matrix/list
 */
async function getApprovalMatrices(
    params = {}
) {

    const res = await axiosClient.get(
        "/api/expense-management/approval-matrix/list",
        {
            params,
        }
    );

    return res.data.data || [];
}

/**
 * --------------------------------------------------------------------------
 * GET APPROVAL MATRIX DETAILS
 * --------------------------------------------------------------------------
 *
 * Backend:
 * GET /api/expense-management/approval-matrix/details/:approvalMatrixId
 */
async function getApprovalMatrix(
    approvalMatrixId
) {

    const res = await axiosClient.get(
        `/api/expense-management/approval-matrix/details/${approvalMatrixId}`
    );

    return res.data.data;
}

/**
 * --------------------------------------------------------------------------
 * CREATE APPROVAL MATRIX
 * --------------------------------------------------------------------------
 *
 * Backend:
 * POST /api/expense-management/approval-matrix/create
 */
async function createApprovalMatrix(
    payload
) {

    const res = await axiosClient.post(
        "/api/expense-management/approval-matrix/create",
        payload
    );

    return res.data.data;
}

/**
 * --------------------------------------------------------------------------
 * UPDATE APPROVAL MATRIX
 * --------------------------------------------------------------------------
 *
 * Backend:
 * PUT /api/expense-management/approval-matrix/update/:approvalMatrixId
 */
async function updateApprovalMatrix(
    approvalMatrixId,
    payload
) {

    const res = await axiosClient.put(
        `/api/expense-management/approval-matrix/update/${approvalMatrixId}`,
        payload
    );

    return res.data.data;
}

/**
 * --------------------------------------------------------------------------
 * DELETE APPROVAL MATRIX
 * --------------------------------------------------------------------------
 *
 * Backend:
 * DELETE /api/expense-management/approval-matrix/delete/:approvalMatrixId
 */
async function deleteApprovalMatrix(
    approvalMatrixId
) {

    const res = await axiosClient.delete(
        `/api/expense-management/approval-matrix/delete/${approvalMatrixId}`
    );

    return res.data;
}

/**
 * --------------------------------------------------------------------------
 * ACTIVATE APPROVAL MATRIX
 * --------------------------------------------------------------------------
 *
 * Backend:
 * PATCH /api/expense-management/approval-matrix/activate/:approvalMatrixId
 */
async function activateApprovalMatrix(
    approvalMatrixId
) {

    const res = await axiosClient.patch(
        `/api/expense-management/approval-matrix/activate/${approvalMatrixId}`
    );

    return res.data.data;
}

/**
 * --------------------------------------------------------------------------
 * DEACTIVATE APPROVAL MATRIX
 * --------------------------------------------------------------------------
 *
 * Backend:
 * PATCH /api/expense-management/approval-matrix/deactivate/:approvalMatrixId
 */
async function deactivateApprovalMatrix(
    approvalMatrixId
) {

    const res = await axiosClient.patch(
        `/api/expense-management/approval-matrix/deactivate/${approvalMatrixId}`
    );

    return res.data.data;
}

/**
 * --------------------------------------------------------------------------
 * EXPORT
 * --------------------------------------------------------------------------
 */

const approvalMatrixService = {

    getApprovalMatrices,

    getApprovalMatrix,

    createApprovalMatrix,

    updateApprovalMatrix,

    deleteApprovalMatrix,

    activateApprovalMatrix,

    deactivateApprovalMatrix,

};

export default approvalMatrixService;